import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import { CustomLoader } from "../CustomLoader";
import { CommonButton } from "./commonButton";
import {
  primaryButtonStyle,
  primaryButtonHoverColor,
  secondaryButtonStyle,
} from "./commonButtonStyles";

function DialogBox({
  title,
  body,
  child,
  confirmText,
  deleteBtnText,
  cancelText = "Cancel",
  isOpen,
  onCancel,
  onConfirm,
  isDisableConfirm = false,
  showConfirmButton = true,
  contentWidth = 300,
  deletePopup,
  width = "100%",
  loading = false,
  maxWidth = "sm"
}) {
  return (
    <Dialog open={isOpen} onClose={onCancel} onBackdropClick="false" maxWidth={maxWidth}>
      <DialogTitle sx={{ padding: "16px 20px 8px 20px", fontSize: "18px", fontWeight: "600" }}>{title}</DialogTitle>
      {loading ? (
        <div
          style={{ minWidth: contentWidth, width: "100%", minHeight: "100px" }}
        >
          <CustomLoader />
        </div>
      ) : (
        <>
          <DialogContent style={{ minWidth: contentWidth, maxWidth: contentWidth, width: "100%", padding: "8px 20px 12px 20px", overflow: "visible", boxSizing: "border-box" }}>
            <div style={{ width: "100%", overflow: "visible", boxSizing: "border-box" }}>
              <DialogContentText sx={{ margin: 0, padding: 0, "& > *": { overflow: "visible", boxSizing: "border-box" } }}>{body}</DialogContentText>
            {(() => {
              try {
                return typeof child === "function" ? child() : child;
              } catch {
                return null;
              }
            })()}
            </div>
          </DialogContent>
          <DialogActions style={{ padding: "8px 20px 16px 20px", margin: 0 }}>
            <CommonButton
              text={cancelText}
              handleClick={onCancel}
              sx={secondaryButtonStyle}
            />
            {deleteBtnText && (
              <Button
                onClick={deletePopup}
                size="medium"
                style={{ padding: "15px 0px", borderRadius: "13px" }}
              >
                {deleteBtnText}
              </Button>
            )}
            {showConfirmButton && (
              <CommonButton
                text={confirmText}
                handleClick={onConfirm}
                disabled={isDisableConfirm}
                sx={primaryButtonStyle}
                hoverColor={primaryButtonHoverColor}
              />
            )}
          </DialogActions>
        </>
      )}
    </Dialog>
  );
}

export default DialogBox;
